import { useMutation, useQuery, useQueryClient } from 'react-query';
import { queryDelete, queryGet } from './fetch';

export interface LinkedinAccount {
  id: string;
  accountId: string;
  linkedinId: string;

  firstName?: string;
  lastName?: string;
  email?: string;
  emailVerified?: boolean;

  pictureUrl?: string;
  locale?: string;
}

export const useLinkedinAccount = (accountId?: string) => {
  return useQuery<LinkedinAccount>(
    ['v2', 'accounts', accountId, 'linkedin-account'],
    queryGet(`/v2/accounts/${accountId}/linkedin-account`),
    {
      enabled: !!accountId,
    },
  );
};

export const useDisconnectLinkedinAccount = (
  accountId?: string,
  participantId?: string,
) => {
  const queryClient = useQueryClient();
  return useMutation(
    queryDelete(`/v2/accounts/${accountId}/linkedin-account`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          'v2',
          'accounts',
          accountId,
          'linkedin-account',
        ]);
        setTimeout(() => {
          queryClient.invalidateQueries(['participants', participantId]);
        }, 400);
      },
    },
  );
};
